<template>
  <Multiselect
      mode="multiple"
      :canDeselect="!disabled"
      :canClear="!disabled"
      :disabled="disabled"
      :closeOnSelect="false"
      :hideSelected="false"
      :options="options"
      v-model="currentIds"
      valueProp="id"
      label="key"
      class="form-control"
      :searchable="true"
      :placeholder="$t('contracts.general_terms')"
  >
    <template v-slot:option="{ option }">
      <span>{{ option.key }}</span>
    </template>
  </Multiselect>
</template>

<script>
import Multiselect from "@vueform/multiselect/src/Multiselect.vue";
import {useGeneralTermStore} from "@/stores/general_term";

export default {
  name: "GeneralTermSelect",
  components: {
    Multiselect,
  },
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    // Extra general terms that should be included even if they were not
    // part of the loaded options, e.g. terms already assigned to the contract.
    extraOptions: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    return {
      generalTermStore: useGeneralTermStore(),
    }
  },
  created() {
    this.generalTermStore.indexAll()
  },
  computed: {
    options() {
      const all = this.generalTermStore.allGeneralTerms || []
      const knownIds = new Set(all.map((gt) => gt.id))
      const missingExtras = (this.extraOptions || []).filter((gt) => gt?.id && !knownIds.has(gt.id))
      return [...all, ...missingExtras].sort((a, b) => (a.key || '').localeCompare(b.key || ''))
    },
    currentIds: {
      get() {
        return this.modelValue
      },
      set(values) {
        values = values || []
        this.$emit('update:modelValue', values)
        // also emit a plain "change" so this component can be used inside a
        // vee-validate <Field v-slot="{ field, handleChange }"> the same way
        // the underlying Multiselect is used elsewhere in the app.
        this.$emit('change', values)
      },
    },
  },
}
</script>
